

















import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';
import Entity from '@/views/Entity.vue';
import GetSupplierStatuses from '@/graphql/GetSupplierStatuses.gql';
import EntityCrud from '@/classes/EntityCrud';
import PimcoreIntrospectionMixin from '@/mixins/PimcoreIntrospectionMixin';

@Component({
  components: {
    Entity,
  },
})
export default class Supplier extends Mixins(PimcoreIntrospectionMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'Supplier',
  }) readonly localStoragePrefix!: string;

  entityCrud!: EntityCrud;

  statusesSelectItems: Record<string, any>[] = [];

  loading = true;

  idsFilter = '';

  get getOnlyColumns() {
    return ['id', 'erp_id', 'legal_name', 'inn', 'contract_email', 'StatusSupplier', 'actions'];
  }

  get entity() {
    return this.$route.params.entityName;
  }

  get blockSupplierStatus() {
    return this.statusesSelectItems.find((status) => status.name === 'Блокировка');
  }

  async mounted() {
    const statuses = await this.fetchSupplierStatuses();
    this.statusesSelectItems = statuses;
    this.loading = false;
  }

  async fetchSupplierStatuses() {
    const statuses = await this.$apollo.query({ query: GetSupplierStatuses });

    return statuses.data?.getStatusSupplierListing?.edges
      .map(({ node }: any) => ({
        id: node.id,
        name: node.name,
      }));
  }

  handleSupplierDisable(item: any) {
    const input = {
      StatusSupplier: {
        id: this.blockSupplierStatus?.id,
        type: 'object',
      },
    };
    this.entityCrud.update(item.id, input);
    this.$bus.$emit('entity-refetch');
  }

  @Watch('entity', { immediate: true })
  async onEntityChange(value: string, oldValue: string) {
    if (value !== oldValue) {
      this.entityCrud = new EntityCrud(this.entity, this.$apollo);
    }
  }
}

